import React from "react";
import axios from "axios";
import { Button } from "primereact/button";
import { jsPDF } from "jspdf";
import logo from "../../assets/logo.png";


function addHeaderFooter(doc: jsPDF, id: number) {
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
//   const logoImg = (document.getElementById("hiddenLogo") as HTMLImageElement)?.src;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, pageWidth, 25, "F");

    if (logo) {
      doc.addImage(logo, "PNG", 15, 5, 40, 15);
    }

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(50, 50, 50);
    const detailsText = `Détails du projet N°${id}`;
    const detailsWidth = doc.getTextWidth(detailsText);
    doc.text(detailsText, pageWidth - detailsWidth - 15, 17);

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(150, 150, 150);
    const footerText = `Détails Projet N°${id}`;
    doc.text(footerText, pageWidth / 2, pageHeight - 10, { align: "center" });
  }
}

function addClientInfoSection(
  doc: jsPDF,
  yStart: number,
  categories: any[],
  field: any
) {
  const x = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const maxWidth = pageWidth - x * 2;

  if (yStart + 40 > doc.internal.pageSize.getHeight() - 20) {
    doc.addPage();
    yStart = 26;
  }

  doc.setFillColor(2, 159, 228);
  doc.rect(x, yStart, maxWidth, 12, "F");
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text("Informations du client", x + 6, yStart + 8);

  let y = yStart + 18;

  const clientInfos = [
    ["Nom", field.nom_prenom || ""],
    ["Téléphone", field.telephone || ""],
    ["Email", field.email || ""],
    [
      "Catégorie",
      categories.find((cat) => cat.idtally == field.id_cat)?.title ||
        "Non définie",
    ],
  ];

  for (const [label, value] of clientInfos) {
    if (label && value) {
      if (y + 20 > doc.internal.pageSize.getHeight() - 20) {
        doc.addPage();
        y = 26;
      }

      doc.setFillColor(240, 240, 240);
      doc.rect(x + 4, y - 3, maxWidth - 8, 8, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(50, 50, 50);
      doc.text(label, x + 6, y + 2);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(30, 30, 30);
      const splitValue = doc.splitTextToSize(value, maxWidth - 12);
      doc.text(splitValue, x + 8, y + 10);

      y += Math.max(18, splitValue.length * 6 + 12);
    }
  }

  return y + 6;
}

function addProjectDetailsSection(doc: jsPDF, yStart: number, fields: any) {
  const x = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const maxWidth = pageWidth - x * 2;

  if (yStart + 40 > doc.internal.pageSize.getHeight() - 20) {
    doc.addPage();
    yStart = 26;
  }

  doc.setFillColor(2, 159, 228);
  doc.rect(x, yStart, maxWidth, 12, "F");
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text("Détails du projet", x + 6, yStart + 8);

  let y = yStart + 18;

  for (let i = 4; i <= 17; i++) {
    const title = fields[`title_${i}`] || "";
    const value = fields[`value_${i}`] || "";

    if (title && value) {
      if (y + 20 > doc.internal.pageSize.getHeight() - 20) {
        doc.addPage();
        y = 26;
      }

      doc.setFillColor(240, 240, 240);
      doc.rect(x + 4, y - 3, maxWidth - 8, 8, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(50, 50, 50);
      doc.text(title, x + 6, y + 2);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(30, 30, 30);
      const splitValue = doc.splitTextToSize(value, maxWidth - 12);
      doc.text(splitValue, x + 8, y + 10);

      y += Math.max(18, splitValue.length * 6 + 12);
    }
  }
  return y + 6;
}

function addAdditionalInfoSection(doc, yStart, fields) {
  const x = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const maxWidth = pageWidth - x * 2;

  // Assurez-vous que le nom du champ (infoSup) correspond bien à la clé dans devisData
  const additionalInfos = [["Notes :", fields.infoSup || ""]];

  const infosToDisplay = additionalInfos.filter(([label, value]) => value);

  if (infosToDisplay.length === 0) {
    return yStart;
  }

  if (yStart + 40 > doc.internal.pageSize.getHeight() - 20) {
    doc.addPage();
    yStart = 26;
  }

  doc.setFillColor(2, 159, 228);
  doc.rect(x, yStart, maxWidth, 12, "F");
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text("Informations Supplémentaires", x + 6, yStart + 8);

  let y = yStart + 18;

  for (const [label, value] of infosToDisplay) {
    if (y + 20 > doc.internal.pageSize.getHeight() - 20) {
      doc.addPage();
      y = 26;
    }

    doc.setFillColor(240, 240, 240);
    doc.rect(x + 4, y - 3, maxWidth - 8, 8, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);
    doc.text(label, x + 6, y + 2);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(30, 30, 30);

    const splitValue = doc.splitTextToSize(value, maxWidth - 12);
    doc.text(splitValue, x + 8, y + 10);

    y += Math.max(18, splitValue.length * 6 + 12);
  }

  return y + 6;
}



async function createPdf(id: number) {
  try {
    const { data: devisData } = await axios.get(`https://www.zotdevis.com/admin/get_devis.php?id=${id}`);
const { data: categoriesRes } = await axios.get(
  "https://suivi.zotdevis.com/zotCategorie.php"
);
const categories = categoriesRes.categories || []; 


    const doc = new jsPDF("p", "mm", "a4");
    let y = 26;

    y = addClientInfoSection(doc, y, categories, devisData);
    y = addProjectDetailsSection(doc, y, devisData);
    y = addAdditionalInfoSection(doc,y,devisData);

    addHeaderFooter(doc, id);
    doc.save(`details_projet_${id}.pdf`);
  } catch (err) {
    console.error("Erreur génération PDF:", err);
    alert("Impossible de générer le PDF");
  }
}


export default function PdfButton({ rowData }: { rowData: any }) {
  return (
    <Button
      icon="pi pi-file-pdf"
      severity="danger"
      size="small"
      onClick={() => createPdf(rowData.id)}
    />
  );
}
